<template>
  <main class="p-3">
    <b-container v-if="apiReady && axisReady" fluid>
      <b-row>
        <b-col cols="12">
          <div class="page-breadcrumb">
            <router-link :to="{ name: 'ExploreAnalysisIndex' }" class="border-0">
              <i class="fa fa-angle-left" /> Back to analysis
            </router-link>
          </div>
        </b-col>
      </b-row>

      <ExploreAnalysisForm
        :allow-submit="allowSubmit"
        :axis="axis"
        :form="form"
        :year-limit="yearLimit"
        :year-range="yearRange"
        @callback="submit"
      >
        <div class="section-header">
          <h1 class="heading">Create analysis</h1>

          <div class="actions"></div>
        </div>
      </ExploreAnalysisForm>
    </b-container>
  </main>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import InitApi from "../Shared/InitApi";
import AnalysisHelpers from "./AnalysisHelpers";
import ExploreAnalysisForm from "./ExploreAnalysisForm";

export default {
  name: "ExploreAnalysisCreate",
  components: {
    ExploreAnalysisForm
  },
  extends: InitApi,
  data() {
    return {
      axisReady: false,
      allowSubmit: true,
      yearRange: null,
      yearLimit: [],
      form: {
        type: null,
        name: null,
        description: null,
        recentyear: null,
        startyear: null,
        stopyear: null,
        includeSubset: false,
        addClustering: true
      },
      axis: {
        x: {},
        y: {},
        z: {}
      }
    };
  },
  computed: {
    ...mapState({
      analyses: state => state.analyse.analyses,
      apiId: state => state.api.apiId,
      apiReady: state => state.api.apiReady,
      documentsPerYear: state => state.document.documentsPerYear,
      metas: (state) => state.ttc.metas,
    })
  },
  watch: {
    apiReady() {
      const yearMin = parseInt(_.minBy(this.documentsPerYear, "year").year);
      const yearMax = parseInt(_.maxBy(this.documentsPerYear, "year").year);
      this.yearRange = [yearMin, yearMax];
      this.yearLimit = [yearMin, yearMax - 2, yearMax];
    },
    yearLimit(val) {
      this.form.startyear = val[0];
      this.form.recentyear = val[1];
      this.form.stopyear = val[2];
    },
    form: {
      deep: true,
      handler(val) {
        if (val.type === "worldmap") {
          this.axis.x.levels.length = 1;
          this.axis.x.levels[0].grouped = false;
          this.axis.x.levels[0].includeAll = false;
          let country = "";
          if(this.metas["Country"]){
            country = this.metas["Country"][0][0];
          }
          else if(this.metas["Location"]){
            country = this.metas["Location"][0][0];
          }
          else if(this.metas["Country Code"]){
            country = this.metas["Country Code"][0][0];
          }
          else{
            country = "scopuscountry";
          }
          this.axis.x.levels[0].layers = [
            {
              label: "Country",
              value: [country, 0],
              searchable: true
            }
          ];
        }
        if (val.type === "linechart") {
          this.axis.x.levels.length = 1;
          this.axis.x.levels[0].grouped = false;
          this.axis.x.levels[0].includeAll = false;
          this.axis.x.levels[0].layers = [
            {
              label: "Time",
              value: ["yr", 0],
              searchable: true
            }
          ];
        }
      }
    }
  },
  mounted() {
    this.loadFilters();
    this.initAxis();

    if (this.documentsPerYear.length > 0) {
      const yearMin = parseInt(_.minBy(this.documentsPerYear, "year").year);
      const yearMax = parseInt(_.maxBy(this.documentsPerYear, "year").year);
      this.yearRange = [yearMin, yearMax];
      this.yearLimit = [yearMin, yearMax - 2, yearMax];
    }
  },
  methods: {
    ...mapActions(["loadFilters", "saveAnalyse"]),
    initAxis() {
      ["x", "y", "z"].forEach(d => {
        this.axis[d] = {
          dimension: d,
          levels: [
            {
              id: 1,
              modifiers: [],
              grouped: false,
              includeAll: false,
              linked: false,
              layers: [],
              //max: 1000
            }
          ]
        };
      });

      this.axisReady = true;
    },
    submit() {
      const insertID = parseInt(
        moment().format("x") + Math.floor(Math.random() * 100)
      );

      const payload = {
        _id: insertID,
        name: this.form.name,
        description: this.form.description,
        config: {
          type: this.form.type,
          query: {
            xlayers: AnalysisHelpers.buildQueryLayers(this.axis.x),
            ylayers: [],
            zlayers: [],
            subset_filters: [],
            startyear: this.form.startyear,
            recentyear: this.form.recentyear,
            stopyear: this.form.stopyear,
            postprocessing: []
          }
        },
        // Add some extra data to easily load when editing analysis
        axis: this.axis,
        includeSubset: this.form.includeSubset,
        addClustering: this.form.addClustering
      };

      if (
        [
          "heatmap",
          "clustermap"
          //"onedheatmap",
          //"barchart",
          //"columnchart",
          //"linechart"
        ].includes(this.form.type)
      ) {
        payload.config.query.ylayers = AnalysisHelpers.buildQueryLayers(
          this.axis.y
        );

        if (this.form.addClustering) {
          payload.config.query.postprocessing = ["clustering"];
        }
      }

      if (this.form.includeSubset) {
        payload.config.query.zlayers = AnalysisHelpers.buildQueryLayers(
          this.axis.z
        );
      }

      this.allowSubmit = false;
      this.saveAnalyse({ analyse: payload }).then(() => {
        this.allowSubmit = true;
        this.$toasted.show("Analysis created");
        setTimeout(() => {
          this.$router.push({
            name: "ExploreAnalysisView",
            params: { id: insertID }
          });
        }, 1000);
      });
    }
  }
};
</script>
